import { PlusCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Drawer,
  Form,
  Select,
  TreeSelect,
  Typography,
  message,
} from "antd";
import React, { useState } from "react";
import { store } from "../../../redux/configStore";
import { createTrademarkCompanyMap } from "../../../api/Trademark/TrademarkCompanyMap";

const { Text } = Typography;

/**
 * Drawer gán Đơn vị ↔ Thương hiệu (chọn cả 2 trong 1 chỗ).
 * props: branchOptions (treeData), trademarkOptions ([{label,value}]), onSuccess()
 */
export default function FormAddTrademarkCompanyMapping({
  isModalOpen,
  handleCancel,
  branchOptions = [],
  trademarkOptions = [],
  onSuccess,
}) {
  const [isLoadCreate, setIsLoadCreate] = useState(false);
  const [formRef] = Form.useForm();

  const onFinish = async (values) => {
    setIsLoadCreate(true);
    try {
      const response = await store.dispatch(
        createTrademarkCompanyMap({
          mcoupon_branch_id: values.mcoupon_branch_id,
          trademark_ids: values.trademark_ids,
        })
      );
      if (createTrademarkCompanyMap.fulfilled.match(response)) {
        if (response.payload?.data?.original) {
          message.error(response.payload.data.original.message);
        } else {
          message.success("Gán thương hiệu cho đơn vị thành công");
          formRef.resetFields();
          handleCancel();
          onSuccess && onSuccess();
        }
      } else {
        const errs = response.payload?.errors;
        if (errs) {
          Object.values(errs).flat().forEach((m) => message.error(m));
        } else {
          message.error(response.payload?.error || response.payload?.message || "Gán thất bại");
        }
      }
    } catch (error) {
      message.error("Đã xảy ra lỗi khi gán thương hiệu.");
    } finally {
      setIsLoadCreate(false);
    }
  };

  return (
    <Drawer
      title={
        <span style={{ fontSize: 18, fontWeight: 700 }}>
          Gán thương hiệu cho đơn vị
        </span>
      }
      open={isModalOpen}
      onClose={handleCancel}
      width={560}
      destroyOnClose
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            padding: "4px 0",
          }}
        >
          <Button onClick={handleCancel} style={{ minWidth: 80 }}>
            Hủy
          </Button>
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            // Footer nằm ngoài <Form> nên htmlType="submit" không chạy -> submit bằng instance.
            onClick={() => formRef.submit()}
            loading={isLoadCreate}
            style={{ minWidth: 120 }}
          >
            Gán liên kết
          </Button>
        </div>
      }
    >
      <Form
        name="addTrademarkCompany"
        form={formRef}
        onFinish={onFinish}
        layout="vertical"
        requiredMark="optional"
        style={{ marginTop: 8 }}
      >
        <Form.Item
          label="Đơn vị"
          name="mcoupon_branch_id"
          rules={[{ required: true, message: "Vui lòng chọn đơn vị" }]}
        >
          <TreeSelect
            placeholder="Chọn đơn vị"
            showSearch
            treeLine
            allowClear
            treeData={branchOptions}
            filterTreeNode={(input, node) =>
              node.title.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item
          label="Thương hiệu"
          name="trademark_ids"
          rules={[{ required: true, message: "Vui lòng chọn thương hiệu" }]}
          extra={
            <Text type="secondary" style={{ fontSize: 12 }}>
              Mỗi lần gán 1 thương hiệu. Bật/tắt thương hiệu đang dùng gửi SMS ở bảng bên ngoài.
            </Text>
          }
        >
          <Select
            placeholder="Chọn thương hiệu"
            allowClear
            showSearch
            optionFilterProp="label"
            options={trademarkOptions}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
}
